(function () {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /******INSTAGRAM POST SLIDER*****/
  const igEl = document.querySelector('.instragram--gallary');
  if (igEl && typeof Swiper !== 'undefined') {
    new Swiper('.instragram--gallary', {
      spaceBetween: 16,
      slidesPerView: 1,
      freeMode: false,
      loop: true,
      centeredSlides: true,
      lazy: true,
      keyboard: { enabled: true },
      breakpoints: {
        300: { slidesPerView: 1.3 },
        480: { slidesPerView: 2 },
        992: { slidesPerView: 4 },
      },
    });
  }

  /*******REVIEWS SLIDER FUNCTIONALITY****/
  const reviewEl = document.querySelector('.review--slider');
  if (reviewEl && typeof Swiper !== 'undefined') {
    new Swiper(".review--slider", {
      spaceBetween: 24,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        320: { slidesPerView: 1.3, spaceBetween: 15 },
        480: { slidesPerView: 2, spaceBetween: 24 },
        990: { slidesPerView: 3.3 }
      },
      pagination: { el: ".swiper-pagination", clickable: true },
    });
  }

  /*******ANNOUCEMENT BAR SLIDER******/
  const annEl = document.querySelector('.annoucement-swiper-slider');
  if (annEl && typeof Swiper !== 'undefined') {
    new Swiper(".annoucement-swiper-slider", {
      loop: true,
      slidesPerView: 1,
      direction: "vertical",
      autoplay: { delay: 3000, disableOnInteraction: false },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }
    });
  }

  /*******ALIFBRICKS 3 SLIDER******/
  const alifEl = document.querySelector('.alifbrick--3-slider');
  if (alifEl && typeof Swiper !== 'undefined') {
    new Swiper(".alifbrick--3-slider", {
      slidesPerViews: 3,
      spaceBetween: 15,
      breakpoints: {
        320: { slidesPerView: 1.1, pagination: { enabled: true } },
        480: { slidesPerView: 2.1 },
        750: { pagination: { enabled: false } },
        990: { slidesPerView: 3 }
      },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      pagination: { el: ".swiper-pagination", clickable: true }
    });
  }

  /**************************************************
   * Add-to-cart trigger (declare early; used below) *
   **************************************************/
  const bundleProductTrigger = document.querySelector("[bundleProductTrigger]");

  /******PRICE CHANGE ACCORDING TO BUNDLE*****/
  const activeBundler = document.querySelector("[bundle--box].active");
  if (activeBundler) {
    if (activeBundler.classList.contains("choosable-bundle-product")) {
      const priceNode = activeBundler.querySelector("[bundle-choose-price]:not(.hidden)");
      if (priceNode) changePrice(priceNode.innerHTML);
    } else {
      const priceNode = activeBundler.querySelector("[bundle--product-price]");
      if (priceNode) changePrice(priceNode.innerHTML);
    }
  }

  function changePrice(element) {
    const priceBlock = document.querySelector("[product--price--block]");
    if (!priceBlock) return;
    priceBlock.innerHTML = element;
  }

  /****CHANGE ADD TO CART BUTTON BEHAVIOUR****/
  function buttonTextChange(foundElement) {
    if (!bundleProductTrigger) return;
    if (foundElement) {
      bundleProductTrigger.setAttribute("disabled", true);
      const t = bundleProductTrigger.querySelector("[add-to-cart-text]");
      if (t) t.innerHTML = theme?.variantStrings?.soldOut || "Sold out";
    } else {
      bundleProductTrigger.removeAttribute("disabled");
      const t = bundleProductTrigger.querySelector("[add-to-cart-text]");
      if (t) t.innerHTML = theme?.variantStrings?.addToCart || "Add to cart";
    }
  }

  function buttonChange(element) {
    if (!element) return;
    if (element.classList.contains("choosable-bundle-product")) {
      const active = element.querySelector("[bundle--chooseable].active");
      const foundElement = active ? active.getAttribute("data-product-sold") : null;
      buttonTextChange(foundElement);
    } else {
      const foundElement = element.getAttribute("data-product-sold");
      buttonTextChange(foundElement);
    }
  }

  /*******BUNDLE PRODUCT FUNCTIONALITY*****/
  const bundleBox = document.querySelectorAll("[bundle--box]");
  if (bundleBox.length) {
    bundleBox.forEach(function (e) {
      e.addEventListener("click", function () {
        const current = document.querySelector("[bundle--box].active");
        if (current) current.classList.remove("active");
        this.classList.add("active");
        const priceNode = this.querySelector("[bundle--product-price]");
        if (priceNode) changePrice(priceNode.innerHTML);
        buttonChange(this);
      });
    });
  }

  /*****BUNDLE CHOOSING TRIGGER AND FUNCTIONALITY*****/
  function changeBundle(element, foundElement, foundId) {
    const main = element.closest("[bundle--choose-main]");
    const box = element.closest("[bundle--box]");
    if (!main || !box) return;

    const activeChoice = main.querySelector("[bundle--chooseable].active");
    if (activeChoice) activeChoice.classList.remove("active");
    foundElement.classList.add("active");

    const currentPrice = box.querySelector("[bundle--chooseable-price]:not(.hidden)");
    if (currentPrice) currentPrice.classList.add("hidden");

    const nextPrice = box.querySelector("[bundle--chooseable-price][data-id='" + foundId + "']");
    if (nextPrice) nextPrice.classList.remove("hidden");

    if (nextPrice) changePrice(nextPrice.innerHTML);
  }

  const bundlerChooseTrigger = document.querySelectorAll("[bundler--choose-trigger]");
  bundlerChooseTrigger.forEach(function (e) {
    e.addEventListener("click", function () {
      const main = this.closest("[bundle--choose-main]");
      if (!main) return;
      const foundElement = main.querySelector("[bundle--chooseable]:not(.active)");
      if (!foundElement) return;
      const foundId = foundElement.dataset.id;
      changeBundle(this, foundElement, foundId);
      buttonChange(this.closest("[bundle--box]"));
    });
  });

  const bundleChooseable = document.querySelectorAll("[bundle--chooseable]");
  if (bundleChooseable.length > 0) {
    bundleChooseable.forEach(function (e) {
      e.addEventListener("click", function () {
        const foundId = this.dataset.id;
        changeBundle(this, this, foundId);
        buttonChange(this.closest("[bundle--box]"));
      });
    });
  }

  /***********************
   * Cards active toggle *
   ***********************/
  const cards = document.querySelectorAll('.combination-cards .card');
  cards.forEach((card) => {
    card.addEventListener('click', () => {
      cards.forEach((c) => c.classList.remove('active'));
      card.classList.add('active');
    });
  });

  /*********************************
   * Custom selects (all dropdowns) *
   *********************************/
  document.querySelectorAll('.custom-select-container').forEach(container => {
    const selectedElement = container.querySelector('.custom-select-selected');
    const optionsContainer = container.querySelector('.custom-select-options');
    const options = container.querySelectorAll('.custom-select-option');
    const selectedImg = container.querySelector('#selected-img');
    const selectedTitle = container.querySelector('#selected-title');

    if (!selectedElement || !optionsContainer) return;

    // IMPORTANT: store Customizer defaults (image + title) so we can reset later (esp. 4th dropdown)
    if (selectedImg && !selectedImg.dataset.defaultSrc) selectedImg.dataset.defaultSrc = selectedImg.src;
    if (selectedTitle && !selectedTitle.dataset.defaultText) selectedTitle.dataset.defaultText = selectedTitle.textContent;

    selectedElement.addEventListener('click', () => {
      selectedElement.classList.add('active_slected');
      selectedElement.classList.toggle('active');
      optionsContainer.classList.toggle('show');
    });

    options.forEach(option => {
      option.addEventListener('click', function () {

        options.forEach(opt => {
          const inputs = opt.querySelectorAll('input');
          inputs.forEach(input => input.classList.remove('ready_cart_id'));
          opt.classList.remove('selected_opt');
        });

        this.classList.add('selected_opt');
        const title = this.getAttribute('data-title');
        const image = this.getAttribute('data-image');

        if (selectedImg) selectedImg.src = image;
        if (selectedTitle) selectedTitle.textContent = title;

        optionsContainer.classList.remove('show');

        const inputs = this.querySelectorAll('input');
        inputs.forEach(input => {
          const variantName = input.getAttribute('data-name');

          const actualMatchVariants = document.querySelector('.product-form__input input[type=radio]:checked+label');
          if (actualMatchVariants) {
            const vnametext = actualMatchVariants.innerText;
            const empty_hide = vnametext.trim();
            if (variantName === empty_hide) {
              input.classList.add('ready_cart_id');
            }
          }
        });
      });
    });
  });

  /**************************
   * Language dropdown logic *
   **************************/
  const selectedContainerl = document.querySelector('.custom-select-selectedl');
  const optionsContainerl = document.querySelector('.custom-select-optionsl');
  const selectedImgl = document.getElementById('selected-imgl');
  const selectedTitlel = document.getElementById('selected-titlel');
  const selectedVariantInputl = document.getElementById('selected-variant');
  const optionsl = document.querySelectorAll('.custom-select-optionl');
  const remove_validation_text = document.querySelector('.set_cross_popup ');

  if (selectedContainerl && optionsContainerl) {
    selectedContainerl.addEventListener('click', () => {
      selectedContainerl.classList.toggle('active');
      selectedContainerl.classList.add('unlock_validation');
      optionsContainerl.classList.toggle('active');
    });

    optionsl.forEach(option => {
      option.addEventListener('click', function () {
        if (remove_validation_text) remove_validation_text.classList.remove('poup_show');
        selectedContainerl.classList.remove('required_field');

        const title = this.getAttribute('data-title');
        const image = this.getAttribute('data-image');
        const variantId = this.getAttribute('data-variant-id');

        if (selectedImgl) selectedImgl.src = image;
        if (selectedTitlel) selectedTitlel.textContent = title;

        optionsContainerl.classList.remove('active');

        if (selectedVariantInputl) selectedVariantInputl.value = variantId;

        optionsl.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');

        const click_title_mt = title;
        const labels = document.querySelectorAll('.js.product-form__input.variant-input-wrapper label');

        labels.forEach(label => {
          const all_current_variants = label.textContent.trim();
          if (all_current_variants === click_title_mt) {
            const correspondingInput = label.previousElementSibling;
            if (correspondingInput) correspondingInput.click();

            const agian_add_ready_click = document.querySelectorAll('.selected_opt input');
            agian_add_ready_click.forEach(option_previous => {
              option_previous.classList.remove('ready_cart_id');
            });

            agian_add_ready_click.forEach(option_gr => {
              const get_seleted_option_input = option_gr.getAttribute('data-name');
              if (get_seleted_option_input === click_title_mt) {
                option_gr.classList.add('ready_cart_id');
              }
            });
          }
        });
      });
    });
  }

  /************************
   * Bundle Add To Cart    *
   * (EXTENDED TO 4 SETS)  *
   * LANGUAGE VALIDATION REMOVED *
   ************************/
  const bundle_second_check = document.querySelector('.unique_second .custom-select-selected');
  const validation_check = document.querySelector('.custom-select-selectedl');
  const validation_check_sder = document.querySelector('.custom-select-containerl .custom-select-selectedl');
  const default_class_add_second = document.querySelector('.custom-select-container.unique_second');
  const addclass_add_val_second = document.querySelector(".unique_second .custom-select-selected");

  function getActiveSetCount() {
    if (document.querySelector('.set_build_four.active')) return 4;
    if (document.querySelector('.set_build_three.active')) return 3;
    if (document.querySelector('.set_build_two.active')) return 2;
    return 1;
  }

  function getSelectedVariantId(containerSelector) {
    const selectedOption = document.querySelector(containerSelector + ' .custom-select-options .selected_opt');
    if (!selectedOption) return "";

    // Prefer the one that matches the currently selected variant (ready_cart_id)
    const ready = selectedOption.querySelector('.ready_cart_id');
    if (ready && ready.value) return ready.value;

    // Fallback: first visible variant input
    const any = selectedOption.querySelector('input.variants_hidden_field:not(.hide_disbled_vrr)');
    return any?.value || "";
  }

  if (bundleProductTrigger) {
    bundleProductTrigger.addEventListener("click", function () {

      // LANGUAGE VALIDATION COMPLETELY REMOVED
      // No more checking if language is selected
      
      const count = getActiveSetCount();

      const inputValue_first = getSelectedVariantId('.unique_first');
      const inputValue_second = (count >= 2) ? getSelectedVariantId('.unique_second') : "";
      const inputValue_third = (count >= 3) ? getSelectedVariantId('.unique_third') : "";
      const inputValue_fourth = (count >= 4) ? getSelectedVariantId('.unique_fourth') : "";

      const id_list = [inputValue_first, inputValue_second, inputValue_third, inputValue_fourth];
      const qty_list = [
        inputValue_first ? 1 : 0,
        inputValue_second ? 1 : 0,
        inputValue_third ? 1 : 0,
        inputValue_fourth ? 1 : 0
      ];

      const empty_modify_array = id_list.filter(id => id !== "");
      const empty_modify_qty_array = qty_list.filter((qty, index) => id_list[index] !== "");

      // Build proper Shopify payload (adds multiple items)
      const items = empty_modify_array.map((id, i) => ({
        id: id,
        quantity: empty_modify_qty_array[i] || 1
      }));

      if (!items.length) return;

      const trigger = this;
      const miniCart = document.querySelector('mini-cart');

      trigger.setAttribute('disabled', true);
      trigger.classList.add('loading');

      const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
      const body = JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              detail: { errorMessage: parsedState.description }
            }));
          } else {
            miniCart && miniCart.renderContents(parsedState);
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: parsedState }
            }));
          }
        })
        .catch((e) => console.error(e))
        .finally(() => {
          trigger.classList.remove('loading');
          trigger.removeAttribute('disabled');
        });
    });
  }

  /***********************
   * Bundle settings gate *
   ***********************/
  const remove_validation_second_cls = document.querySelector('.unique_second .custom-select-selected');
  const remove_validation_second_cls_gaoin = document.querySelector('.custom-select-container.unique_second');
  const validation_line_second = document.querySelector('.set_cross_popup');

  if (remove_validation_second_cls) {
    remove_validation_second_cls.addEventListener('click', () => {
      remove_validation_second_cls.classList.remove('required_field_lable');
      if (remove_validation_second_cls_gaoin) remove_validation_second_cls_gaoin.classList.add('cta_default_second');
      if (validation_line_second) validation_line_second.classList.remove('poup_show');
    });
  }

  /****************************************
   * Disable/Enable bundle dropdowns by set
   * (EXTENDED TO 4 SETS)
   ****************************************/
  const first_set = document.querySelector(".set_build_one");
  const second_set = document.querySelector(".set_build_two");
  const third_set = document.querySelector(".set_build_three");
  const fourth_set = document.querySelector(".set_build_four");

  const builder_one = document.querySelector(".unique_first");
  const builder_second = document.querySelector(".unique_second");
  const builder_third = document.querySelector(".unique_third");
  const builder_fourth = document.querySelector(".unique_fourth");

  const set_two_click_remove = document.querySelector(".custom-select-container.unique_second");

  function setDisabled(el, disabled) {
    if (!el) return;
    if (disabled) el.classList.add("disabled");
    else el.classList.remove("disabled");
  }

  // Reset 4th dropdown (image back to Customizer default + title to unlock text) WITHOUT needing a placeholder option
  function resetFourthDropdownToUnlock() {
    const c = document.querySelector('.unique_fourth');
    if (!c) return;

    // Clear selected option / ready ids so it doesn't "stick"
    c.querySelectorAll('.custom-select-option').forEach(opt => {
      opt.classList.remove('selected_opt');
      opt.querySelectorAll('input').forEach(i => i.classList.remove('ready_cart_id'));
    });

    // Reset image to Customizer default
    const img = c.querySelector('#selected-img');
    if (img && img.dataset.defaultSrc) img.src = img.dataset.defaultSrc;

    // Reset title to unlock text (from hidden span), else fallback to default title
    const titleEl = c.querySelector('#selected-title');
    const unlockEl = document.querySelector('.unloac_set_four_cta');
    if (titleEl) {
      if (unlockEl && unlockEl.textContent.trim() !== "") {
        titleEl.textContent = unlockEl.textContent.trim();
      } else if (titleEl.dataset.defaultText) {
        titleEl.textContent = titleEl.dataset.defaultText;
      }
    }
  }

  // 1 set
  if (first_set) {
    first_set.addEventListener("click", () => {
      if (set_two_click_remove) set_two_click_remove.classList.add('cta_default_second');
      setDisabled(builder_one, false);
      setDisabled(builder_second, true);
      setDisabled(builder_third, true);
      setDisabled(builder_fourth, true);

      resetFourthDropdownToUnlock();
    });
  }

  // 2 sets
  if (second_set) {
    second_set.addEventListener("click", () => {
      setDisabled(builder_one, false);
      setDisabled(builder_second, false);
      setDisabled(builder_third, true);
      setDisabled(builder_fourth, true);

      if (set_two_click_remove) set_two_click_remove.classList.remove("cta_default_second");

      resetFourthDropdownToUnlock();
    });
  }

  // 3 sets
  if (third_set) {
    third_set.addEventListener("click", () => {
      if (set_two_click_remove) set_two_click_remove.classList.add('cta_default_second');
      setDisabled(builder_one, false);
      setDisabled(builder_second, false);
      setDisabled(builder_third, false);
      setDisabled(builder_fourth, true);

      resetFourthDropdownToUnlock();
    });
  }

  // 4 sets
  if (fourth_set) {
    fourth_set.addEventListener("click", () => {
      if (set_two_click_remove) set_two_click_remove.classList.add('cta_default_second');
      setDisabled(builder_one, false);
      setDisabled(builder_second, false);
      setDisabled(builder_third, false);
      setDisabled(builder_fourth, false);
      // When 4 sets is active we do NOT reset; user can choose
    });
  }

  /************************************************
   * Auto-apply defaults on load for all dropdowns *
   ************************************************/
  const preSelectedOptions = document.querySelectorAll('.custom-select-option.selected_opt');
  preSelectedOptions.forEach(option => option.click());

  /************************************************
   * Helper: reset a select to its placeholder opt *
   ************************************************/
  function clickIfExists(sel) {
    const el = document.querySelector(sel);
    if (el) el.click();
  }

  function setSelectedTitle(containerSel, unlockTextSel) {
    const titleEl = document.querySelector(containerSel + ' #selected-title');
    const unlockEl = document.querySelector(unlockTextSel);
    if (!titleEl) return;
    if (unlockEl) {
      titleEl.textContent = unlockEl.innerHTML;
    }
  }

  function selectByTitleContains(containerSel, containsText) {
    const opts = document.querySelectorAll(containerSel + ' .custom-select-options .custom-select-option');
    const found = Array.from(opts).find(o => {
      const t = (o.getAttribute('data-title') || '').toLowerCase();
      return t.includes((containsText || '').toLowerCase());
    });
    if (found) found.click();
  }

  /**************************************
   * Card click behaviors (reset/select) *
   **************************************/
  const cardSetBuildTwo = document.querySelector('.set_build_two');
  if (cardSetBuildTwo) {
    cardSetBuildTwo.addEventListener("click", () => {
      // reset 2nd/3rd selectors to placeholder (existing behavior)
      clickIfExists('.unique_second .second_option_select_work');
      clickIfExists('.unique_third .third_option_select_work');

      // 4th: reset image/title + unlock text (works even without placeholder)
      resetFourthDropdownToUnlock();

      // show unlock text for ones that are locked
      setSelectedTitle('.unique_third', '.unloac_set_three_cta');
      setSelectedTitle('.unique_fourth', '.unloac_set_four_cta');
    });
  }

  const cardSetBuildThree = document.querySelector('.set_build_three');
  if (cardSetBuildThree) {
    cardSetBuildThree.addEventListener("click", () => {
      // your previous forced selections (kept, but guarded)
      clickIfExists('.unique_third .custom-select-options .custom-select-option:nth-child(4)');
      clickIfExists('.unique_second .custom-select-options .custom-select-option:nth-child(3)');

      // 4th: reset to unlock
      resetFourthDropdownToUnlock();
      setSelectedTitle('.unique_fourth', '.unloac_set_four_cta');
    });
  }

  const cardSetBuildone = document.querySelector('.set_build_one');
  if (cardSetBuildone) {
    cardSetBuildone.addEventListener("click", () => {
      // reset 2nd/3rd selectors to placeholder
      clickIfExists('.unique_second .second_option_select_work');
      clickIfExists('.unique_third .third_option_select_work');

      // 4th: reset to unlock
      resetFourthDropdownToUnlock();

      // unlock labels for locked ones
      setSelectedTitle('.unique_second', '.unloac_set_second_cta');
      setSelectedTitle('.unique_third', '.unloac_set_three_cta');
      setSelectedTitle('.unique_fourth', '.unloac_set_four_cta');
    });
  }

  // 4 sets card: ensure defaults are selected for all four dropdowns
  const cardSetBuildFour = document.querySelector('.set_build_four');
  if (cardSetBuildFour) {
    cardSetBuildFour.addEventListener("click", () => {
      selectByTitleContains('.unique_first', 'Kaaba');
      selectByTitleContains('.unique_second', 'Al-Aqsa');
      selectByTitleContains('.unique_third', 'Masjid');
      selectByTitleContains('.unique_fourth', 'Makkah');
    });
  }

  /************************************************
   * Initial load: make sure locked 4th resets      *
   * (so it doesn't keep old chosen product image)  *
   ************************************************/
  if (!document.querySelector('.set_build_four.active')) {
    resetFourthDropdownToUnlock();
  }

  /************************************************
   * Initial load: if 4th card is the default active,
   * click it once so all enable/disable + defaults apply
   ************************************************/
  const activeCard = document.querySelector('.combination-cards .card.active');
  if (activeCard) {
    activeCard.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }

  /***********************
   * Dutch/German disable *
   ***********************/
  setTimeout(function () {
    const germanInput = document.querySelector('input[value="German"]');
    const dutchInput = document.querySelector('input[value="Dutch"]');
    const dutchDisableGenr = document.querySelector('.custom-select-optionsl');

    if (germanInput && dutchInput && germanInput.disabled && dutchInput.disabled) {
      if (dutchDisableGenr) dutchDisableGenr.classList.add('remove_dutch_german');
    }
  }, 1000);

})();